// extracted by mini-css-extract-plugin
module.exports = {"chestImageWrapper":"_58a5c0f","defaultChestImage":"_9dd575a","multiChestImage":"_a9e492f"};